import partnerEditor 				from '../components/editors/partnerEditor';
import CompanyEditor 				from '../components/editors/companyeditor';
import ProductEditor 				from '../components/editors/productEditor';
import ArticleEditor 				from '../components/editors/ArticleEditor';
import EmailTemplateEditor 			from '../components/editors/EmailTemplateEditor';
import NewsletterEditor 			from '../components/editors/NewsletterEditor';
import LandingPageEditor 			from '../components/editors/landingpageeditor';
import emailcampaignEditor 			from '../components/editors/emailcampaigneditor';
import {
	default as purchaseEditor,
	purchasesEditor,
    SupplyPurchasesEditor,
	PurchaseReturnsEditor,
	ConsignmentPurchasesEditor
} 									from '../components/editors/purchaseEditor';
import OperationListEditor 			from '../components/editors/OperationList/OperationListEditor';
import SalesEditor 					from '../components/editors/OperationList/SalesEditor';
import ReturnGoodsEditor 			from '../components/editors/OperationList/ReturnGoodsEditor';
import RepurchaseEditor 			from '../components/editors/OperationList/RepurchaseEditor';
import RetraxitEditor 				from '../components/editors/OperationList/RetraxitEditor';
import CreditNoteEditor 			from '../components/editors/OperationList/CreditNoteEditor';
import ShopReturnGoodsEditor 		from '../components/editors/OperationList/ShopReturnGoodsEditor';
import ConsignmentReceiptEditor 	from '../components/editors/OperationList/ConsignmentReceiptEditor';
import ConsignmentReturnEditor 		from '../components/editors/OperationList/ConsignmentReturnEditor';
import PurchaseReturnEditor 		from '../components/editors/OperationList/PurchaseReturnEditor';
import ConsignmentDeliveryEditor 	from '../components/editors/OperationList/ConsignmentDeliveryEditor';
import ConsignmentPurchaseEditor 	from '../components/editors/OperationList/ConsignmentPurchaseEditor';
import ConsignmentSaleEditor 		from '../components/editors/OperationList/ConsignmentSaleEditor';
import WholeSaleConsignmentEditor 	from '../components/editors/OperationList/WholeSaleConsignmentEditor';
import WholeSalePurchaseEditor 		from '../components/editors/OperationList/WholeSalePurchaseEditor';
import SupplyPurchaseEditor 		from '../components/editors/OperationList/SupplyPurchaseEditor';
import SupplyPurchaseReturnEditor 	from '../components/editors/OperationList/SupplyPurchaseReturnEditor';
import SupplyOrderEditor		 	from '../components/editors/OperationList/SupplyOrderEditor';
import WriteOffOperationList, {WriteOffEditorList} from '../components/editors/OperationList/WriteOffEditor';
import PrivilegeEditor 				from '../components/editors/PrivilegeEditor';
import GroupEditor 					from '../components/editors/groupeditor';
import MembercardEditor 			from '../components/editors/MembercardEditor';
import RuleBookEditor 				from '../components/editors/RuleBookEditor';
import userEditor 					from '../components/editors/userEditor';
import FilteredStockEditor			from '../components/editors/FilteredStockEditor';
import ShopItemStockEditor 			from '../components/editors/ShopItemStockEditor';
import invoiceEditor 				from '../components/editors/invoiceEditor';
import {
	default as paymentEditor,
	ReversePaymentsEditor
} 				from '../components/editors/paymentEditor';
import {
	default as stocktransferEditor,
    ConsignmentStockTransferEditor
} 													from '../components/editors/stocktransferEditor';
import menuEditor 									from '../components/editors/menuEditor';
import locationEditor 								from '../components/editors/locationEditor';
import ApiLocationEditor							from '../components/editors/ApiLocationEditor';
import ApiClientEditor 								from '../components/editors/ApiClientEditor';
import storeEditor 									from '../components/editors/storeEditor';
import productionitemEditor 						from '../components/editors/productionitemEditor';
import shippingorderEditor 							from '../components/editors/shippingorderEditor';
import shippingEditor 								from '../components/editors/shippingEditor';
import ShippingTourEditor 							from '../components/editors/ShippingTourEditor';
import StoreOrderImport 							from "../components/actionforms/StoreOrderImport";
import DiscountEditor 								from "../components/editors/DiscountEditor";
import PromotionEditor 								from "../components/editors/PromotionEditor";
import businesstransactionEditor 					from "../components/editors/businesstransactionEditor";
import MoneyTransferEditor		 					from "../components/editors/MoneyTransferEditor";
import InvoicingEditor 								from "../components/editors/InvoicingEditor";
import MoneyTransferDocumentEditor 					from "../components/editors/MoneyTransferDocumentEditor";
import TillEditor 									from "../components/editors/TillEditor";
import SortimentEditor 								from "../components/editors/SortimentEditor";
import InventoryEditor 								from "../components/editors/OperationList/InventoryEditor";
import ShopSalesEditor 								from "../components/editors/OperationList/ShopSalesEditor";
import ShopSupplementEditor 						from "../components/editors/OperationList/ShopSupplementEditor";
import BooklogStoreOrderStatusEditor				from "../components/editors/BooklogStoreOrderStatusEditor";
import BooklogStoreOrderEditor						from "../components/editors/storeorder/BooklogStoreOrderEditor";
import {StoreOrderClaims} 							from "../components/editors/storeorder/BooklogStoreOrderEditor";
import {
	default as StoreOrderBuilderEditor,
	StoreOrderBuilderInEditor,
	StoreOrderBuilderOutEditor,
	StoreOrderBuilderDamagedEditor,
} 													from "../components/editors/storeorder/StoreOrderBuilderEditor";
import BooklogStoreOrderInEditor 					from "../components/editors/storeorder/BooklogStoreOrderInEditor";
import ShopStoreOrderInEditor 						from "../components/editors/storeorder/ShopStoreOrderInEditor";
import BooklogStoreOrderOutEditor 					from "../components/editors/storeorder/BooklogStoreOrderOutEditor";
import BooklogStoreOrderDamagedEditor 				from "../components/editors/storeorder/BooklogStoreOrderDamagedEditor";
import UnknownStoreOrderEditor						from "../components/editors/storeorder/UnknownStoreOrderEditor";
import ComponentConfigEditor 						from "../components/editors/ComponentConfigEditor";
//import StatisticsEditor 							from "../components/editors/Statistics/StatisticsEditor";
import StatisticsEditor 							from "../components/editors/Statistics/StatisticsEditor3";
import StatEditor									from "../components/editors/Statistics/StatEditor";
import ProductClassEditor 							from "../components/editors/ProductClassEditor";
import tagEditor		 							from "../components/editors/tagEditor";
import seriesEditor		 							from "../components/editors/seriesEditor";
import videoEditor		 							from "../components/editors/videoEditor";
import staticcontentEditor							from "../components/editors/staticcontentEditor";
import galleryEditor		 						from "../components/editors/galleryEditor";
import ProgramEditor 								from "../components/editors/ProgramEditor";
import EventEditor 									from "../components/editors/EventEditor";
import EventReservationEditor						from "../components/editors/EventReservationEditor";
import authorEditor 								from "../components/editors/authorEditor";
import imageEditor 									from "../components/editors/imageEditor";
import figureEditor 								from "../components/editors/figureEditor";
import MoneyRepositoryEditor 						from "../components/editors/MoneyRepositoryEditor";
import TillRepositoryEditor 						from "../components/editors/TillRepositoryEditor";
import TillClosingEditor	 						from "../components/editors/TillClosingEditor";
import {
	default as PersonalPickupEditor,
	FailedPersonalPickupEditor
}								 					from "../components/editors/PersonalPickupEditor";
import VatRateEditor	 							from "../components/editors/vatrateEditor";
import TimeConfigEditor	 							from "../components/editors/TimeConfigEditor";
import ProgramPriceEditor	 						from "../components/editors/ProgramPriceEditor";
import TradenameEditor	 							from "../components/editors/tradenameEditor";
import CampaignEditor	 							from "../components/editors/CampaignEditor";
import StoreOrderClaimEditor	 					from "../components/editors/StoreOrderClaimEditor";
import BergmanInvoiceExport		 					from "../components/editors/pagony/BergmanInvoiceExport";
import ReleaseInfo									from "../components/ReleaseInfo";
import ConsignmentReportEditor						from "../components/editors/ConsignmentReportEditor";
import WriteOffEditor 								from "../components/editors/WriteOffEditor";
import RichSnippetEditor 							from "../components/editors/RichSnippetEditor";
import pageEditor		 							from "../components/editors/pageEditor";
import BannerEditor		 							from "../components/editors/BannerEditor";
import RoyaltyEditor 								from "../components/editors/RoyaltyEditor";
import RoyaltyRangeEditor 							from "../components/editors/RoyaltyRangeEditor";
import RoyaltyLicensorEditor 						from "../components/editors/RoyaltyLicensorEditor";
import VoucherEditor		 						from "../components/editors/VoucherEditor";
import RoyaltyReportEditor	 						from "../components/editors/RoyaltyReportEditor";
import CurrentUserEditor 							from '../components/editors/CurrentUserEditor';
import OptInSubscriberEditor 						from '../components/editors/OptInSubscriberEditor';
import OptInEditor 									from '../components/editors/OptInEditor';
import OptInSourceEditor							from '../components/editors/OptInSourceEditor';
import MagazineEditor 								from '../components/editors/MagazineEditor';
import ColorEditor 									from '../components/editors/ColorEditor';
import MaterialEditor 								from '../components/editors/MaterialEditor';
import ProductCategoryEditor 						from '../components/editors/ProductCategoryEditor';
import LabelEditor			 						from '../components/editors/LabelEditor';
import TourEditor 									from '../components/editors/TourEditor';

export const componentMappings = {
	company: 											CompanyEditor,
	partner: 											partnerEditor,
	product: 											ProductEditor,
	article: 											ArticleEditor,
	EmailTemplate: 										EmailTemplateEditor,
	Newsletter: 										NewsletterEditor,
	LandingPage: 										LandingPageEditor,
	emailcampaign: 										emailcampaignEditor,
	purchase: 											purchaseEditor,
	purchases: 											purchasesEditor,
	OperationList: 										OperationListEditor,
	SupplyPurchase: 									SupplyPurchaseEditor,
    SupplyPurchaseReturn: 								SupplyPurchaseReturnEditor,
	Sales: 												SalesEditor,
	ShopSales: 											ShopSalesEditor,
	ConsignmentReceipt: 								ConsignmentReceiptEditor,
    ConsignmentReturn: 									ConsignmentReturnEditor,
	PurchaseReturn: 									PurchaseReturnEditor,
	ConsignmentDelivery: 								ConsignmentDeliveryEditor,
	ConsignmentPurchase: 								ConsignmentPurchaseEditor,
	ConsignmentPurchases: 								ConsignmentPurchasesEditor,
	ConsignmentSale: 									ConsignmentSaleEditor,
	WholeSaleConsignment: 								WholeSaleConsignmentEditor,
	WholeSalePurchase:									WholeSalePurchaseEditor,
    ReturnGoods: 										ReturnGoodsEditor,
    Repurchase: 										RepurchaseEditor,
	Retraxit: 											RetraxitEditor,
    CreditNote: 										CreditNoteEditor,
    ShopReturnGoods: 									ShopReturnGoodsEditor,
    SupplyOrder:		 								SupplyOrderEditor,
	Privilege: 											PrivilegeEditor,
	Group: 												GroupEditor,
	Membercard: 										MembercardEditor,
	RuleBook: 											RuleBookEditor,
	user: 												userEditor,
	stock: 												FilteredStockEditor,
    ShopItemStock: 										ShopItemStockEditor,
	invoice: 											invoiceEditor,
	payment: 											paymentEditor,
	ReversePayments: 									ReversePaymentsEditor,
	stocktransfer: 										stocktransferEditor,
    ConsignmentStockTransfer: 							ConsignmentStockTransferEditor,
	menu: 												menuEditor,
	location: 											locationEditor,
	apilocation: 										ApiLocationEditor,
	apiclient: 											ApiClientEditor,
	store: 												storeEditor,
    productionitem: 									productionitemEditor,
	ProductClass: 										ProductClassEditor,
	tag: 												tagEditor,
	series: 											seriesEditor,
	video: 												videoEditor,
	gallery: 											galleryEditor,
    staticcontent: 										staticcontentEditor,
	StoreOrderImport: 									StoreOrderImport,
    shippingorder: 										shippingorderEditor,
	shipping: 											shippingEditor,
	ShippingTour: 										ShippingTourEditor,
	Discount: 											DiscountEditor,
	Promotion: 											PromotionEditor,
    businesstransaction: 								businesstransactionEditor,
	TransactionPayment: 								MoneyTransferEditor,
	Invoicing: 											InvoicingEditor,
    MoneyTransferDocument: 								MoneyTransferDocumentEditor,
    Till: 												TillEditor,
	Sortiment: 											SortimentEditor,
	ShopSupplement: 									ShopSupplementEditor,
	StoreOrderBuilder:		 							StoreOrderBuilderEditor,
	StoreOrderBuilderIn:		 						StoreOrderBuilderInEditor,
	StoreOrderBuilderOut:		 						StoreOrderBuilderOutEditor,
	StoreOrderBuilderDamaged:		 					StoreOrderBuilderDamagedEditor,
    BooklogStoreOrderStatus: 							BooklogStoreOrderStatusEditor,
    BooklogStoreOrder: 									BooklogStoreOrderEditor,
	StoreOrderClaims: 									StoreOrderClaims,
	BooklogStoreOrderIn: 								BooklogStoreOrderInEditor,
	BooklogStoreOrderOut:								BooklogStoreOrderOutEditor,
	BooklogStoreOrderDamaged:							BooklogStoreOrderDamagedEditor,
	UnknownStoreOrder:									UnknownStoreOrderEditor,
	Statistics: 										StatisticsEditor,
	ComponentConfig: 									ComponentConfigEditor,
	Program: 											ProgramEditor,
	Event: 												EventEditor,
    EventReservation: 									EventReservationEditor,
	author: 											authorEditor,
	image: 												imageEditor,
	figure: 											figureEditor,
    ShopStoreOrderIn:									ShopStoreOrderInEditor,
    MoneyRepository:									MoneyRepositoryEditor,
    TillRepository:										TillRepositoryEditor,
    TillClosing:										TillClosingEditor,
	PersonalPickup:										PersonalPickupEditor,
	FailedPersonalPickup:								FailedPersonalPickupEditor,
	vatrate:											VatRateEditor,
    TimeConfig:											TimeConfigEditor,
    ProgramPrice:										ProgramPriceEditor,
    tradename:											TradenameEditor,
    SupplyPurchases:									SupplyPurchasesEditor,
	PurchaseReturns:									PurchaseReturnsEditor,
    Campaign:											CampaignEditor,
    StoreOrderClaim:									StoreOrderClaimEditor,
    InvoiceExport:										BergmanInvoiceExport,
    ReleaseInfo:										ReleaseInfo,
    ConsignmentReport:									ConsignmentReportEditor,
	WriteOffs:											WriteOffEditor,
	AuthorsCopy: 										WriteOffOperationList("AuthorsCopy"),
	EditorialCopy: 										WriteOffOperationList("EditorialCopy"),
	ComplimentaryCopy: 									WriteOffOperationList("ComplimentaryCopy"),
	ReviewCopy: 										WriteOffOperationList("ReviewCopy"),
	LegalDeposit: 										WriteOffOperationList("LegalDeposit"),
	Charity: 											WriteOffOperationList("Charity"),
	Damaged: 											WriteOffOperationList("Damaged"),
	Missing: 											WriteOffOperationList("Missing"),
	Giveaway: 											WriteOffOperationList("Giveaway"),
	FreeCopies:											WriteOffEditorList("FreeCopies"),
	WriteOff: 											WriteOffEditorList("WriteOff"),
	RichSnippet:										RichSnippetEditor,
	page:												pageEditor,
    Royalty:											RoyaltyEditor,
    RoyaltyRange:										RoyaltyRangeEditor,
    RoyaltyLicensor:									RoyaltyLicensorEditor,
	Banner:												BannerEditor,
	Voucher:											VoucherEditor,
    RoyaltyReport:										RoyaltyReportEditor,
	currentuser:										CurrentUserEditor,
	OptInSubscriber:									OptInSubscriberEditor,
	OptIn:												OptInEditor,
	OptInSource:										OptInSourceEditor,
	Magazine:											MagazineEditor,
	Color:												ColorEditor,
	Material:											MaterialEditor,
	ProductCategory:									ProductCategoryEditor,
	Stat:												StatEditor,
	Label:												LabelEditor,
	Tour:												TourEditor,
};

export const wholeSaleMappings = {
}

export const componentMapping = ({prefix = "admin"}) => {
	switch (prefix) {
		case "admin":
			return componentMappings;
		case "wholesale":
			return wholeSaleMappings;
	}
}

export const componentIcons = {
	ShippingMenu:		"truck",
	orders:				"clipboard-list",
	System: 			"gear",
	masterdata: 		"database",
	bills: 				"file",
	editors: 			"edit",
	ProductMenu: 		"book",
	marketing: 			"envelope",
	publishing: 		"book",
	commerce: 			"money-bill-wave",
	retail: 			"cash-register",
	Locations: 			"map-marker",
	Statistics: 		"chart-line",
	StatMenu:	 		"chart-line",
	accounting: 		"file-invoice",
	programs: 			"calendar-alt",
	service: 			"hand-holding-usd",
	supply: 			"truck"
};
